const handleChange = (setValue) => (e) => {
    setValue(e.target.value)
}

export default handleChange;